<div class="reports_wrapper">
  <div class="tabs">
    <div class="tabs_block">
      <button
        [class.isActive]="displayCardInsights"
        [class.isInActive]="!displayCardInsights"
        class="tabs_block__btn"
        (click)="openTab()"
      >
        Place Card Insights
      </button>
      <button
        [class.isActive]="displaySpatialInsights"
        [class.isInActive]="!displaySpatialInsights"
        class="tabs_block__btn spatial_insights"
        (click)="openTab()"
      >
        Spatial Insights
      </button>
    </div>
  </div>

  <div class="reports_wrapper__insights" *ngIf="displayCardInsights">
    <div class="insights_block">
      <div class="header-content">
        <h3 class="insights_title">APPLE INSIGHTS</h3>
        <p-progressSpinner
          class="spinner"
          *ngIf="isLoadingPlaceCardInsights"
          styleClass="w-2rem h-2rem"
          strokeWidth="2"
          fill="var(--surface-ground)"
          animationDuration="spinnerAnimationDuration"
        >
        </p-progressSpinner>
      </div>
      <div class="insights_filters">
        <p-dropdown
          [options]="dateRanges"
          [(ngModel)]="selectedRange"
          optionLabel="name"
          optionValue="value"
          (onChange)="dateRangeChanged($event)"
        >
        </p-dropdown>
        <button pButton class="edit p-button-text" icon="fa fa-pen" (click)="editInsights()"></button>
      </div>
    </div>

    <div class="card_holder" [class.full_width]="fullWidth" [class.half_width]="!fullWidth">
      <ng-container *ngFor="let data of demoData">
        <div
          class="chart"
          *ngIf="data.visibility"
          [class.full_width__chart]="fullWidth"
          [class.half_width__chart]="!fullWidth"
        >
          <div class="chart_block">
            <h2 class="chart_block_title">{{ data.title }}</h2>
            <p-chart
              type="bar"
              [data]="data.graphData"
              [options]="insightsGraphConfig"
              width="100%"
              [height]="showReviews ? '18vh' : '22vh'"
            >
            </p-chart>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div class="reports_wrapper__insights spatial_insights" *ngIf="displaySpatialInsights">
  <div class="insights_block">
    <div class="header-content">
      <h3 class="insights_title">APPLE INSIGHTS</h3>
      <p-progressSpinner
        class="spinner"
        *ngIf="isLoadingSpatialInsights"
        styleClass="w-2rem h-2rem"
        strokeWidth="2"
        fill="var(--surface-ground)"
        animationDuration="spinnerAnimationDuration"
      >
      </p-progressSpinner>
    </div>

    <div class="insights_filters">
      <div class="toggle_view">
        <p-toggleButton
          [(ngModel)]="showHeatMap"
          [offLabel]="'Table View'"
          [onLabel]="'Heat Map'"
          [onIcon]="'pi pi-globe'"
          [offIcon]="'pi pi-table'"
          styleClass="p-button-sm"
        >
        </p-toggleButton>
      </div>
      <!-- Locations dropdown -->
      <p-dropdown
        [options]="locations"
        [(ngModel)]="selectedLocation"
        optionLabel="businessName"
        [filter]="true"
        (onChange)="changeLocation()"
        [virtualScroll]="true"
      >
      </p-dropdown>
      <!-- Calendar -->
      <p-calendar [showIcon]="true" [(ngModel)]="date" view="month" dateFormat="mm/yy" (onSelect)="changeMonth()">
      </p-calendar>
    </div>
  </div>
  <div class="title-block">
    <h2 class="title-block-title">
      Search Clicks Location
      <i
        class="pi pi-info-circle info-icon"
        pTooltip="Shows where people were located when they searched for your location."
        tooltipPosition="top"
      ></i>
    </h2>

    <h2 class="title-block-title">
      Directions Clicks Location
      <i
        class="pi pi-info-circle info-icon"
        pTooltip="Shows where people were located when they requested directions to your location."
        tooltipPosition="top"
      ></i>
    </h2>
  </div>

  <div class="heatmap_container" *ngIf="!showHeatMap">
    <!-- Heat Map Section Search Clicks Direction-->
    <app-mapbox-heatmap
      class="heatmap_container_block"
      mapId="searchMap"
      [searchPoints]="searchLocationsZipCodes"
      [center]="selectedLocation?.lngLat"
      [zoom]="3"
      [isLoading]="isLoadingSpatialInsights"
      [selectedLocation]="selectedLocation"
    >
      ></app-mapbox-heatmap
    >

    <!-- Heat Map Section Directions Clicks -->
    <app-mapbox-heatmap
      class="heatmap_container_block"
      mapId="directionsMap"
      [searchPoints]="directionsLocationsZipCodes"
      [center]="selectedLocation?.latLng"
      [zoom]="3"
      [isLoading]="isLoadingSpatialInsights"
      [selectedLocation]="selectedLocation"
    >
      ></app-mapbox-heatmap
    >
  </div>

  <div class="table_card" *ngIf="showHeatMap">
    <app-insights-table-card
      class="table_card_block"
      [zipCodes]="searchLocationsZipCodes"
      [isLoading]="isLoadingSpatialInsights"
    >
      >
    </app-insights-table-card>
    <app-insights-table-card
      class="table_card_block"
      [zipCodes]="directionsLocationsZipCodes"
      [isLoading]="isLoadingSpatialInsights"
    >
      >
    </app-insights-table-card>
  </div>
</div>

<!-- Dialog code -->
<p-dialog
  id="appleInsights"
  header="Customize Insights"
  [(visible)]="displayInsightsPopup"
  [modal]="true"
  [dismissableMask]="true"
  (onHide)="closeInsightsPopup()"
>
  <div class="insights_container">
    <ng-container *ngFor="let data of popupData">
      console.log(data);
      <div id="{{ data.id }}" class="insights_list">
        <label class="insights_list_label">{{ data.label }}</label>
        <p-checkbox
          name="appleInsights"
          value="{{ data.value }}"
          [(ngModel)]="selectedInsightPrefs"
          (onChange)="prefsChanged()"
        >
        </p-checkbox>
      </div>
    </ng-container>
  </div>

  <!-- Footer -->
  <ng-template pTemplate="footer">
    <div>
      <button
        pButton
        label="CANCEL"
        class="p-button-outlined p-button-secondary"
        (click)="closeInsightsPopup()"
      ></button>
      <button pButton label="SAVE" (click)="saveInsightsPrefs()"></button>
    </div>
  </ng-template>
</p-dialog>
<!-- Footer -->

<!-- Dialog code -->
